import { fetchRequest } from "./Fetcher";

export const SaveProgress = async ({ method = "POST", param = "progress", payload }) => {
  const m = String(method).toUpperCase();
  const cleanParam = String(param).replace(/^\/|\/$/g, "");
  const path = `sessions/${cleanParam}`;

  return fetchRequest({
    method: m,
    path,
    ...(m === "GET" || m === "HEAD" ? {} : { data: JSON.stringify(payload ?? {}) }),
  }).then((r) => r.result);
};